module.exports = "<div class=\"container\">\n\n   <app-breadcrumb\n      [breadcrumbs]=\"breadcrumbs$ | async\"\n      [disableLink]=\"disableLink\">\n   </app-breadcrumb>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /builds/cp/frap/t3/planer/src/app/core/components/breadcrumb/breadcrumb-cont.component.html
// module id = ../../../../../src/app/core/components/breadcrumb/breadcrumb-cont.component.html
// module chunks = main